import React from 'react';
import { AnimatePresence, motion } from 'motion/react';
import type { ChapterId } from './heroTheaterData';
import DiscoverScene from './screens/DiscoverScene';
import EvaluateScene from './screens/EvaluateScene';
import ForecastScene from './screens/ForecastScene';
// import TrackScene from './screens/TrackScene'; // Track chapter paused

interface HeroProductTheaterProps {
  chapterId: ChapterId;
  progress: number;
  reducedMotion: boolean;
}

const sceneTransition = {
  initial: { opacity: 0, y: 8, filter: 'blur(3px)' },
  animate: { opacity: 1, y: 0, filter: 'blur(0px)' },
  exit: { opacity: 0, y: -6, filter: 'blur(3px)' },
  transition: { duration: 0.18, ease: [0.32, 0.72, 0, 1] as const },
};

/**
 * Soft crossfade between stylized mental-model scenes.
 */
export default function HeroProductTheater({
  chapterId,
  progress,
  reducedMotion,
}: HeroProductTheaterProps) {
  return (
    <div className="relative h-full w-full">
      <AnimatePresence mode="wait" initial={false}>
        {chapterId === 'discover' && (
          <motion.div
            key="discover"
            className="absolute inset-0"
            {...(reducedMotion
              ? { initial: false, animate: { opacity: 1 }, exit: { opacity: 0 } }
              : sceneTransition)}
          >
            <DiscoverScene progress={progress} reducedMotion={reducedMotion} />
          </motion.div>
        )}
        {chapterId === 'evaluate' && (
          <motion.div
            key="evaluate"
            className="absolute inset-0"
            {...(reducedMotion
              ? { initial: false, animate: { opacity: 1 }, exit: { opacity: 0 } }
              : sceneTransition)}
          >
            <EvaluateScene progress={progress} reducedMotion={reducedMotion} />
          </motion.div>
        )}
        {chapterId === 'forecast' && (
          <motion.div
            key="forecast"
            className="absolute inset-0"
            {...(reducedMotion
              ? { initial: false, animate: { opacity: 1 }, exit: { opacity: 0 } }
              : sceneTransition)}
          >
            <ForecastScene progress={progress} reducedMotion={reducedMotion} />
          </motion.div>
        )}
        {/* Track chapter paused — restore with CHAPTERS entry in heroTheaterData
        {chapterId === 'track' && (
          <motion.div
            key="track"
            className="absolute inset-0"
            {...(reducedMotion
              ? { initial: false, animate: { opacity: 1 }, exit: { opacity: 0 } }
              : sceneTransition)}
          >
            <TrackScene progress={progress} reducedMotion={reducedMotion} />
          </motion.div>
        )}
        */}
      </AnimatePresence>
    </div>
  );
}
